<!--
    ref... https://www.studytonight.com/post/capture-photo-using-webcam-in-javascript

-->
<div *ngIf="(vm$ | async) as vm">

    <div [ngClass]="{ 'text-center': !vm.display.isLandscape, 'pl-3': true }">
        <div class="contentarea">            
            <div [ngClass]="{ 'd-flex': !vm.display.isLandscape, 'flex-column': !vm.display.isLandscape }">
                <span class="h1-responsive">EmpireCLS</span>
                <small>
                    <span
                        [ngClass]="{ 'h5-responsive': true, 'ml-2': vm.display.isLandscape, 'font-weight-lighter': true }">Secure
                        Identity Check</span>
                    <mdb-icon class="ml-1" fas icon="info-circle" (click)="infoShow(vm)" style="cursor: pointer;"></mdb-icon>
                </small>
            </div>
            <div *ngIf="vm.errorText">
                <span class="text-danger">{{vm.errorText}}</span>
            </div>
            <div *ngIf="vm.completedText" class="pt-5">
                <span>{{vm.completedText}}</span>
            </div>

            <!-- info -->
            <div *ngIf="vm.infoVm as ivm" class="text-center">
                <hr/>
                <div>
                    some disclaimer stuff and link
                </div>
                <div>
                    <small>Version {{ivm.version}}</small>
                </div>
                <app-form-button title="close" outline="true"
                    rounded="true" size="sm" [disabled]="false"
                    (clicked)="infoClosed(vm)">
                </app-form-button>
            </div>

            <!-- camera -->
            <div *ngIf="vm.cameraVm as cvm">
                <div [ngClass]="{ 'd-flex': vm.display.isLandscape, 'justify-content-around': vm.display.isLandscape }">
                    <div>
                        <video *ngIf="!cvm.hasPicture" style="background-color: black;" [attr.width]="vm.display.width"
                            [attr.height]="vm.display.height" #video></video>
                        <canvas *ngIf="cvm.hasPicture" #canvas style="border:1px" [attr.width]="vm.display.width"
                            [attr.height]="vm.display.height" (touchstart)="drawStart(vm, $event)"
                            (touchend)="drawEnd(vm, $event)" (touchmove)="drawMove(vm, $event)"
                            (mousedown)="drawStart(vm, $event)" (mouseup)="drawEnd(vm, $event)"
                            (mousemove)="drawMove(vm, $event)">
                        </canvas>
                    </div>

                    <div class="text-center px-3">
                        <div *ngIf="vm.helpText">
                            <i>{{vm.helpText}}</i>
                        </div>
                        <div [ngClass]="{ 'd-flex': vm.display.isLandscape, 'flex-column': vm.display.isLandscape }">
                            <app-form-button [title]="a.title" *ngFor="let a of vm.actions" outline="true"
                                rounded="true" size="sm" [disabled]="!a.enabled"
                                [color]="a.enabled ? 'primary' : 'warning'" (clicked)="actionInvoke(vm, a)">
                            </app-form-button>
                            <div *ngIf="vm.actionText">
                                <span class="text-error">{{vm.actionText}}</span>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>

    </div>

</div>